import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Tooltip, useTheme } from '@web-chat-core/ui-kit';
import { ReactComponent as IconMicMuted } from 'static/ic-mic_off-16.svg';
import { Bar, Content, IconWrapper, Name, ScreenShareIconWrapper } from './view';

interface Props {
    isAudioMuted: boolean;
    name: string;
    isScreenShareIconShown?: boolean;
    isModerator?: boolean;
    isMainModerator?: boolean;
    isSpeaker?: boolean;
}

export const ParticipantBar = ({
    isAudioMuted,
    isScreenShareIconShown,
    name,
    isModerator,
    isMainModerator,
    isSpeaker,
}: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const moderatorTooltip = isMainModerator
        ? t('moderator_primary_meeting_moderator')
        : t('web_videoconference_meeting_moderator');

    return (
        <Bar>
            <Content>
                {isModerator ? (
                    <Tooltip label={moderatorTooltip}>
                        <IconWrapper>
                            <Icon icon="icModerator24" size={16} color={theme.root.colors.basicColors.white['100%']} />
                        </IconWrapper>
                    </Tooltip>
                ) : null}
                {isSpeaker && !isModerator ? (
                    <Tooltip label={t('vks_speaker')}>
                        <IconWrapper>
                            <Icon icon="icSpeaker16" size={16} color={theme.root.colors.basicColors.white['100%']} />
                        </IconWrapper>
                    </Tooltip>
                ) : null}
                {isScreenShareIconShown ? (
                    <ScreenShareIconWrapper>
                        <Icon icon="icDesktop16" size={12} color={theme.root.colors.basicColors['90%']} />
                    </ScreenShareIconWrapper>
                ) : null}
                {isAudioMuted ? (
                    <IconWrapper>
                        <IconMicMuted />
                    </IconWrapper>
                ) : null}
                <Name>{name}</Name>
            </Content>
        </Bar>
    );
};
